import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {Link} from 'gatsby-link';

function Laverage(props) {
    return (
        <div className="laverage_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={12} xl={10} xxl={10} className="m-auto text-center">
                        <h2>Our Mobile Application Marketing Process</h2>
                        <p>The GCC region is filled with numerous opportunities for new businesses to establish their digital footprint. It is well on its way to becoming a prominent location for technology leaders in the world. The region’s local mobile apps are already making noise in the international tech corridors, and this will continue to happen. Our mobile App marketing process is tailored to the region’s specific needs. Here’s how we market apps for our clients.</p>
                        <p>Here is the process that is followed for custom software development</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={11} className="m-auto">
                        <div className="process_listing">
                            <div className="process_item">
                                <div className="number">01</div>
                                <h6>Research & User Persona Identification</h6>
                                <p>We begin by researching your app’s idea. Based on your inputs and our research, we finalize the user persona to more precisely target the right audience.</p>
                            </div>
                            <div className="process_item">
                                <div className="number">02</div>
                                <h6>Conduct Competitive Analysis</h6>
                                <p>After complete research, we analyze the competitors of your relevant niche to improvise the existing approach and progressively get an edge over them.</p>
                            </div>
                            <div className="process_item">
                                <div className="number">03</div>
                                <h6>Strategic Marketing Plan</h6>
                                <p>The next step is to develop a comprehensive strategic marketing plan for your mobile application from organic marketing to paid campaigns.</p>
                            </div>
                            <div className="process_item">
                                <div className="number">04</div>
                                <h6>Marketing Plan Execution</h6>
                                <p>Now, we begin to work on executing the marketing plan and ensure all the campaigns are executed properly at the hands of TekRevol’s marketing experts</p>
                            </div>
                            <div className="process_item">
                                <div className="number">05</div>
                                <h6>Campaign Monitoring & Optimization</h6>
                                <p>Once executed, TekRevol’s marketing gurus continue monitoring and optimizing the campaigns, ensuring all the app marketing efforts are properly materialized.</p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Laverage;